import wpdmIcons from "../../libs/icons";
import LinkTemplates from "../../libs/link-templates";
import Columns from "../../libs/columns";

const {InspectorControls} = wp.editor;
const {TextControl, TextareaControl, SelectControl, FormToggle, ServerSideRender, Modal, Button, PanelBody} = wp.components;
const {registerBlockType} = wp.blocks;
const {withState} = wp.compose;
const { __ } = wp.i18n;


registerBlockType('download-manager/search', {
    title: 'Search Results',

    description: 'Search Download Manager Packages',

    keywords: [
        __( 'download manager digital ecommerce store product sell' ),
        __( 'file manager' ),
        __( 'product category categories' )
    ],

    icon: wpdmIcons.search(),

    category: 'wpdm-blocks',

    attributes: {
        init: {
            type: 'boolean',
            default: true
        },
        items_per_page: {
            type: 'integer',
            default: 10
        },
        cols: {
            type: 'integer',
            default: 1
        },
        colspad: {
            type: 'integer',
            default: 1
        },
        colsphone: {
            type: 'integer',
            default: 1
        },
        template: {
            type: 'string',
            default: 'link-template-panel'
        },
        className: {
            type: 'string',
            default: ''
        }
    },

    edit({attributes, className, setAttributes}) {


        function onChangeTemplate(newTemplate) {
            setAttributes({ template: newTemplate });
        }

        function onSelectCategory(categories) {
            console.log(categories);
            var selected_cats = [];
            jQuery.each(categories, function (index, category) {
                selected_cats.push(category.value);
            });
            console.log(selected_cats.join(','));
            setAttributes({ categories: selected_cats.join(',') });

        }

        function onExcludeCategory(categories) {
            console.log(categories);
            var selected_cats = [];
            jQuery.each(categories, function (index, category) {
                selected_cats.push(category.value);
            });
            console.log(selected_cats.join(','));
            setAttributes({ xcats: selected_cats.join(',') });

        }

        function onChangeCols(cols) {
            if(cols.cols !== undefined) setAttributes({ cols: cols.cols });
            if(cols.colspad !== undefined) setAttributes({ colspad: cols.colspad });
            if(cols.colsphone !== undefined) setAttributes({ colsphone: cols.colsphone });
            console.log(cols);
        }

        function selectedCats(cats) {
            var selected_cats = [];
            cats = cats.split(',');
            jQuery.each(wpdm_categories, function (index, category) {
                if(cats.indexOf(category.value) !== -1){
                    selected_cats.push(category);
                }
            });
            return selected_cats;
        }

        return ([
            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>


                        <div className={"form-group"}>
                            <FormToggle
                                id={"init"}
                                checked={attributes.init}
                                onChange={init => {
                                    setAttributes({init: init.target.checked});
                                }}
                            />
                            <label htmlFor={"init"} style={{paddingLeft: "5px"}}> Show Initial Results</label>
                        </div>

                        <div className="form-group">
                            <TextControl
                                label={"Items Par Page:"}
                                type={"number"}
                                value={attributes.items_per_page}
                                onChange={ ( items_per_page ) => setAttributes( { items_per_page: items_per_page } ) }
                            />
                        </div>


                        <LinkTemplates
                            label = {"Link Template:"}
                            value = {attributes.template}
                            onChange = {onChangeTemplate}
                        />

                        <div className="form-group">
                            <Columns label={"Columns:"}
                                     cols = { attributes.cols }
                                     colspad = { attributes.colspad }
                                     colsphone = { attributes.colsphone }
                                     onChange = {onChangeCols}
                            />
                        </div>

                    </PanelBody>

                </div>
            </InspectorControls>,
            <ServerSideRender
                block = {"download-manager/search"}
                attributes = {attributes}
            />
        ]);

    },
    save() {
        return null;
    }
});
